import { useEffect } from 'react'

export function useBodyScrollLock(isLocked: boolean, dependencies: any[] = []) {
  useEffect(() => {
    if (typeof document !== 'undefined') {
      document.body.style.overflowY = isLocked ? 'hidden' : ''
    }
  }, [...dependencies, isLocked])
}

export default useBodyScrollLock
